import { CURRENCIES_SIGNS, Currencies } from "@/constants/currency";

export const formatCurrency = (value: number, currency?: string | null) => {
  const formatted = value.toFixed(2);

  switch (currency) {
    case Currencies.EUR:
      return `${CURRENCIES_SIGNS[currency]}${formatted}`;
    case Currencies.USD:
      return `${CURRENCIES_SIGNS[currency]}${formatted}`;
    default:
      formatted;
  }

  return formatted;
};
